export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Heavy.b5abc4a2.woff";